import { render } from "./PostsHead.vue?vue&type=template&id=5a0410ac"
import script from "./PostsHead.vue?vue&type=script&lang=js"
export * from "./PostsHead.vue?vue&type=script&lang=js"

import "./PostsHead.vue?vue&type=style&index=0&id=5a0410ac&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__